import React from 'react';
import BaseComponent from 'base';
import Dialog from '@mui/material/Dialog';
import { Button, DialogActions, DialogContent } from '@mui/material';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { FormattedMessage, injectIntl } from 'react-intl';

class ErrorView extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleClose = () => {
    this.redirect('/');
    location.reload();
  };

  getErrorMessage(statusCode) {
    const errorKeys = {
      999: 'errors.thirdPartyCookies',
      401: 'errors.unauthorizedAccess',
      403: 'errors.insufficientPermissions',
      0: 'errors.genericError',
    };
    
    return this.props.intl.formatMessage({ 
      id: errorKeys[statusCode] || errorKeys[0] 
    });
  }

  render() {
    const search = queryString.parseUrl(location.href);
    // const name = new URLSearchParams(search).get('code');
    const actions = [
      <Button variant="contained" key={'error'} primary onClick={this.handleClose}>
        <FormattedMessage id="common.ok" />
      </Button>,
    ];

    const statusCode = parseInt(search.query.code || '0', 10);
    return (
      <Dialog fullWidth open sx={{ padding: 10 }}>
        <DialogContent>
          {' '}
          <h3><FormattedMessage id="errors.errorOccurred" /></h3>
          {this.getErrorMessage(statusCode)}
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

export default injectIntl(ErrorView);
